import{ updatetheme,themedata }  from '../../../../store/theme_data';
import { useSelector } from "react-redux";
import { useEffect,useState } from 'react';
import dayjs from 'dayjs';


export default function Cardwidget(props){
    const theme = useSelector((state) => state.themedata.theme)
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
    const [optionsmin, setOptionsMin] = useState(0);
    const [optionsmax, setOptionsMax] = useState(0);
    const [optionstimemin, setOptionsTimeMin] = useState(0);
    const [optionstimemax, setOptionsTimeMax] = useState(0);
    const [widgetnamedisplay, setWidgetName] = useState(0);

    useEffect(() => {
        const tagProperties = props.widgetprop.props.extended.tagprops;
        var widgetname = props.widgetprop.widgetname;
        tagProperties.forEach(chartType => {
            
            if (tagcollectionvalue.hasOwnProperty(chartType.tagid)) {
                var nestedvalue = tagcollectionvalue[chartType.tagid]
                console.log("nested value in cardwidget-----<>",nestedvalue)
                var sum = 0.0;
                var min = 10000000000;
                var max = 0.0;
                var mintime = 0.0;
                var maxtime = 0.0;
                var options = { timeZone: "Asia/Kolkata" };
                    for(var i=0;i<nestedvalue.length;i++){
                        if((Number(nestedvalue[i].y) > max) && (nestedvalue[i].y != null)){
                            max = Number(nestedvalue[i].y);
                            var currentmaxformatteddate = new Date(nestedvalue[i].x);
                            var maxformatteddate = currentmaxformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric", month: "short", year: "numeric",hour: "numeric",minute: "numeric",second: "numeric" });
                            maxtime = maxformatteddate;
                        }
                        
                        if((Number(nestedvalue[i].y) < min) && (nestedvalue[i].y != null)){
                            console.log("inside Card Widget min/////////",min,"Number(nestedvalue[i].y)",Number(nestedvalue[i].y))
                            min = Number(nestedvalue[i].y);
                            var currentminformatteddate = new Date(nestedvalue[i].x);
                            var minformatteddate = currentminformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric", month: "short", year: "numeric",hour: "numeric",minute: "numeric",second: "numeric" });
                            mintime = minformatteddate
                        }
                    }
                if(max == 0.0){
                    max = "No Data";
                    maxtime = "No Data";
                }else{
                    max = max.toFixed(2);
                }

                if(min == 10000000000){
                    min = "No Data";
                    mintime = "No Data";
                }else{
                    min = min.toFixed(2);
                }

                console.log("inside Card Widget min",min)
                console.log("inside Card Widget max",max)
                console.log("inside Card Widget mintime",mintime)
                console.log("inside Card Widget max",maxtime)
                setOptionsMin(min);
                setOptionsMax(max);
                setOptionsTimeMin(mintime);
                setOptionsTimeMax(maxtime);
              //  setWidgetName(widgetname)
                
            }
        })
       
        
      },[props.widgetprop, tagcollectionvalue])

    return(
        <>

            <div style={{position:"inline-flex",display:"flex", flexDirection:"row", paddingTop:"60px",alignItems:'baseline',paddingLeft:"20px"}}>
                <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"14px",fontWeight:400}}>Minimum</div>
                <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"24px",fontWeight:400,paddingLeft:"206px"}}>{optionsmin}</div>
            </div>
            <div style={{color:theme=='light'?"#3C3C3C":"#C1C1C1", fontFamily:"Roboto", fontSize:"12px",fontWeight:400,paddingLeft:"235px"}}>{optionstimemin}</div>

            <div style={{position:"inline-flex",display:"flex", flexDirection:"row", paddingTop:"40px",alignItems:'baseline',paddingLeft:"20px",paddingTop:"50px"}}>
                <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"14px",fontWeight:400}}>Maximum</div>
                <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"24px",fontWeight:400,paddingLeft:"206px"}}>{optionsmax}</div>
            </div>
            <div style={{color:theme=='light'?"#3C3C3C":"#C1C1C1", fontFamily:"Roboto", fontSize:"12px",fontWeight:400,paddingLeft:"235px"}}>{optionstimemax}</div>
        </>
    )
}